import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import router from "../../../../router";

const isProjectInvoicesConfirmed = {
    namespaced: true,
    state: {
        areProjectInvoicesConfirmed: false,
        isVisibleWarningModalNotInProjectEdition: false,
        isVisibleWarningModalInProjectEdition: false,
    },
    mutations: {
        SUCCESS_GET_DATA(state, response) {
            state.areProjectInvoicesConfirmed = response.data.data.isConfirmed;
            if (router.currentRoute.name !== 'ProjectsEdit') {
                state.isVisibleWarningModalNotInProjectEdition = response.data.data.isConfirmed ? false : true;
            } else {
                state.isVisibleWarningModalInProjectEdition = response.data.data.isConfirmed ? false : true;
            }       
        },
        UPDATE_VISIBLE_WARNING_MODAL_NOT_IN_PROJECT_EDITION(state, value) {
            state.isVisibleWarningModalNotInProjectEdition = value;
        },
        UPDATE_VISIBLE_WARNING_MODAL_IN_PROJECT_EDITION(state, value) {
            state.isVisibleWarningModalInProjectEdition = value;
        },
        FAILURE_GET_DATA(state, error) {
            console.log(error);
        },
    },
    actions: {
        checkAreProjectInvoicesConfirmedRequest: function({ dispatch }, payload) {
            let promise = sendRequest("get", config.baseURLApi + "/invoices/checkConfirmation/" + payload.projectId, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetData", result[1]);
                } else {
                    dispatch("failureGetData", result[1]);
                }
            });
        },
        updateVisibleWarningModalNotInProjectEdition: function({commit}, value) {
            commit("UPDATE_VISIBLE_WARNING_MODAL_NOT_IN_PROJECT_EDITION", value)
        },
        updateVisibleWarningModalInProjectEdition: function({commit}, value) {
            commit("UPDATE_VISIBLE_WARNING_MODAL_IN_PROJECT_EDITION", value)
        },
        successGetData: function ({commit}, response) {
            commit("SUCCESS_GET_DATA", response)
        },
        failureGetData: function({ commit }, error) {
            commit("FAILURE_GET_DATA", error);
        },
    }
}

export default isProjectInvoicesConfirmed;